import Vue from 'vue';
import FormComponent from '@app/components/Form.vue';
export default Vue.extend({
    components: {
        FormComponent: FormComponent,
    },
    props: {
        block: Object
    }
});
